import React from 'react';
import ButtonTooltipBadge from '../ButtonTooltipBadge/ButtonTooltipBadge';
import { ButtonSubmissionProps } from './ButtonSubmission.type';

const ButtonSubmission: React.FC<ButtonSubmissionProps> = ({ onClick }) => {
  return (
    <ButtonTooltipBadge
      dataTestId="button-submission"
      onClick={onClick}
      title={'My Submission'}
      content={
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="12"
          viewBox="0 0 16 12"
          fill="none"
        >
          <path
            d="M2 12C1.5875 12 1.23438 11.8531 0.940625 11.5594C0.646875 11.2656 0.5 10.9125 0.5 10.5V1.5C0.5 1.0875 0.646875 0.734375 0.940625 0.440625C1.23438 0.146875 1.5875 0 2 0H6.5L8 1.5H14C14.4125 1.5 14.7656 1.64688 15.0594 1.94063C15.3531 2.23438 15.5 2.5875 15.5 3V10.5C15.5 10.9125 15.3531 11.2656 15.0594 11.5594C14.7656 11.8531 14.4125 12 14 12H2ZM3.5 6H12.5V4.5H3.5V6ZM3.5 9H9.5V7.5H3.5V9Z"
            fill="#E4E4E4"
          />
        </svg>
      }
    />
  );
};

export default ButtonSubmission;
